import Rule from "../../../../common/rule";

export default class CollectDriveTime extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return !!fragment.time;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { milliseconds } = fragment.time;
        gameContext.gameClock.setSeconds(milliseconds / 1000);
    }
}
